import React, { useEffect, useState } from "react";
import { VerticalSeparator } from "../../../settingsForms/verticalSeparator";
import { ITagGroup } from "../../../../../models/tagGroups/TagGroupStore";
import settingsStyles from "../../../../../styles/settings.css";
import { TagGroupTransferRuleForm } from "../../types";
import { TagGroupColumn } from "../TagGroupColumn/TagGroupColumn";
import { TargetTagGroupsColumn } from "../TargetTagGroupsColumn/TargetTagGroupsColumn";

interface Props {
  allTagGroups: ITagGroup[];
  unusedTagGroups: ITagGroup[];
  form: TagGroupTransferRuleForm;
  isEditing: boolean;
  isNewItem?: boolean;
  hasError: boolean | undefined;
}

export const TagRuleBox = ({
  allTagGroups,
  unusedTagGroups,
  form,
  isEditing,
  isNewItem
}: Props) => {
  const [tagGroupId, setTagGroupId] = useState<string>(form.$.tagGroupId.$);
  const [targetTagGroupIds, setTargetTagGroupIds] = useState<string[]>([]);

  useEffect(() => {
    setTargetTagGroupIds(form.$.targetTagGroupIds.$);
  }, [form.$.targetTagGroupIds.$]);

  const onTagGroupChange = (newTagGroup: ITagGroup) => {
    setTagGroupId(newTagGroup.id);
    form.$.tagGroupId.reset(newTagGroup.id);
    setTargetTagGroupIds([]);
    form.$.targetTagGroupIds.reset([]);
  };

  const onTargetGroupsChange = (newTagGroup: ITagGroup) => {
    if (newTagGroup) {
      const newTargets = [...targetTagGroupIds, newTagGroup.id];

      setTargetTagGroupIds(newTargets);
      form.$.targetTagGroupIds.reset(newTargets);
    }
  };

  const onTargetDelete = (deleteTagGroupId: string) => {
    const newTargets = targetTagGroupIds.filter((target) => target !== deleteTagGroupId);
    setTargetTagGroupIds(newTargets);
    form.$.targetTagGroupIds.reset(newTargets);
  };

  const targetGroupsItemProvider = () =>
    tagGroupId
      ? allTagGroups.filter((item) => !targetTagGroupIds.some((target) => item.id === target))
      : [];

  const tagGroup = allTagGroups.find((item) => item.id === tagGroupId);
  return (
    <div className={settingsStyles.flex}>
      <TagGroupColumn
        onChange={onTagGroupChange}
        optionsItemProvider={() => unusedTagGroups}
        isEditing={!!(isEditing && isNewItem)}
        tagGroupName={tagGroup?.name || ""}
        enabled={!!tagGroup?.enabled}
        hasError={form.$.tagGroupId.hasError}
      />
      <VerticalSeparator />
      <TargetTagGroupsColumn
        isEditing={isEditing}
        tagGroupId={tagGroupId}
        allTagGroups={allTagGroups}
        targetTagGroupIds={targetTagGroupIds}
        onDelete={onTargetDelete}
        onChange={onTargetGroupsChange}
        optionsItemProvider={targetGroupsItemProvider}
        hasError={form.$.targetTagGroupIds.hasError}
      />
    </div>
  );
};
